export default __webpack_public_path__ + "static/media/logo-mobile.574082e5.png";